import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import {
  DSButton,
  DSInput,
} from "@components/design-system/molecules";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { defaultErrorHandler } from "../../utils/operationTracking";
import { alert } from "../common/Alert";

const UPDATE_FORGOTTEN_PASSWORD_MUTATION = gql`
  mutation updateForgottenPassword(
    $token: String
    $password: String
  ) {
    updateForgottenPassword(token: $token, password: $password) {
      ok
    }
  }
`;

export default function ForgotPasswordReset() {
  let { resetToken } = useParams();
  let navigate = useNavigate();

  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors },
  } = useForm();

  const [updateForgottenPassword] = useMutation(
    UPDATE_FORGOTTEN_PASSWORD_MUTATION,
  );

  function submitPassword({ password }) {
    updateForgottenPassword({
      variables: {
        token: resetToken,
        password: password,
      },
    })
      .then((response) => {
        const { ok } = response.data.updateForgottenPassword;

        if (ok) {
          alert(
            "success",
            "Password updated successfully! Redirecting to our login page...",
          );
          setTimeout(function () {
            navigate("/auth/login");
          }, 3500);
        }
      })
      .catch(defaultErrorHandler);
  }

  return (
    <form
      onSubmit={handleSubmit(submitPassword)}
      className="flex-col items-center justify-center sm:px-6 lg:px-8"
    >
      <div className="space-y-8">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-primary">
          Reset your Scribenote password below 🙈
        </h2>
        <div className="max-w-96 mx-auto">
          <div className={"py-2"}>
            <h4 className="my-2">New Password</h4>
            <Controller
              control={control}
              name="password"
              rules={{ required: true }}
              render={({ field }) => (
                <DSInput
                  type="password"
                  placeholder={"Type your new password"}
                  dataTestId="reset-password"
                  {...field}
                />
              )}
            />
          </div>
          <div className={"py-2"}>
            <h4 className="my-2">Confirm New Password</h4>
            <Controller
              control={control}
              name="passwordConfirmation"
              rules={{
                required: "Please confirm password!",
                validate: {
                  matchesPreviousPassword: (value) => {
                    const { password } = getValues();
                    return (
                      password === value || "Passwords should match!"
                    );
                  },
                },
              }}
              render={({ field }) => (
                <DSInput
                  type="password"
                  placeholder={"Confirm your new password"}
                  dataTestId="reset-password-confirm"
                  {...field}
                />
              )}
            />
          </div>
          {errors.passwordConfirmation && (
            <p className="text-danger text-xs text-center">
              {errors.passwordConfirmation.message}
            </p>
          )}

          <div className="w-full flex justify-center mt-md">
            <DSButton
              type="submit"
              variant="primary"
              size="lg"
              dataTestId="reset-password-submit"
            >
              Submit
            </DSButton>
          </div>
        </div>
      </div>
    </form>
  );
}
